import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { NoData } from '../_components/NoData';
import { apiConstants } from '../_constants';

export const SubjectsList = ({ subjects }) => {
  const navigate = useNavigate();
  const subjectContainerRef = useRef(null);
  const [searchkey, setSearchkey] = useState('');
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const handleSearch = (e) => {
    const { value } = e.target;
    setSearchkey(value);
  };

  useEffect(() => {
    const checkScroll = () => {
      if (subjectContainerRef.current) {
        const { scrollLeft, scrollWidth, clientWidth } = subjectContainerRef.current;
        setShowLeftArrow(scrollLeft > 0);
        setShowRightArrow(scrollLeft < scrollWidth - clientWidth);
      }
    };

    checkScroll(); // Initial check
    const container = subjectContainerRef.current;
    container.addEventListener('scroll', checkScroll); // Add scroll event listener

    return () => {
      container.removeEventListener('scroll', checkScroll); // Cleanup
    };
  }, []);

  const scrollContainer = (direction) => {
    if (subjectContainerRef.current) {
      const scrollAmount = direction === 'left' ? -350 : 350; // Determine scroll direction
      subjectContainerRef.current.scrollBy({ left: scrollAmount, behavior: 'smooth' }); // Scroll by 300px
    }
  };

  const filteredSubjects = subjects?.filter((sub) => {
    const searchTermLowerCase = searchkey.toLowerCase();
    const subjectNameLowerCase = sub.subject_name.toLowerCase();
    return subjectNameLowerCase.includes(searchTermLowerCase);
  });
  return (
    <div className='subjectlist'>
      <div className='mt-5'>
        <div className='search_baground' style={{ maxWidth: '370px' }}>
          <img src='/img/Search.png' className='searchicon' />
          <input
            className='search_course'
            value={searchkey}
            onChange={handleSearch}
            type='text'
            name='searchKey'
            aria-label='Search'
            placeholder='Search for a Subject'
          />
        </div>
      </div>
      <div className='position-relative'>
        {showLeftArrow && (
          <div
            className='scrollleft'
            onClick={() => {
              scrollContainer('left');
            }}
          >
            <img src='/img/left-angle.png' alt='' className='leftarrowicon' />
          </div>
        )}
        <div className=' subjectcontainer mt-4 pb-5' ref={subjectContainerRef}>
          {filteredSubjects?.map((sub, index) => {
            return (
              <div
                className='subjectbox'
                key={index}
                onClick={() => {
                  navigate(`/topiclist/${sub?._id}`, { state: { title: sub.subject_name } });
                }}
              >
                <img
                  src={
                    sub?.subject_image
                      ? apiConstants.imgUrl + sub?.subject_image
                      : '/img/subjectdummy.jpeg'
                  }
                  alt=''
                  className='subjectimg'
                />
                <div className='subdescription'>
                  <h1 className='subname '>{sub.subject_name}</h1>

                  <div className='coursedesc d-flex'>
                    <div className='descitem'>
                      <img src='/img/book_icon.png' className='desc_icon' /> {sub?.topicCount}{' '}
                      Topics
                    </div>
                    <div className='descitem'>
                      <img src='/img/question_icon.png' className='desc_icon' />{' '}
                      {sub?.QuestionCounts} Questions
                    </div>
                  </div>
                </div>
                <div
                  className='d-flex justify-content-center mt-3'
                  onClick={() => navigate(`/topiclist/${sub?._id}`, { state: { title: sub.subject_name } })}
                >
                  <div className='viewtopicbtn'>View Topics</div>
                </div>
              </div>
            );
          })}

          {filteredSubjects?.length == 0 && <NoData text='No Subjects Found' className='mt-2' />}
        </div>
        {showRightArrow && (
          <div
            className='scrollright'
            onClick={() => {
              scrollContainer('right');
            }}
          >
            <img src='/img/right-angle.png' alt='' className='leftarrowicon' />
          </div>
        )}
      </div>
    </div>
  );
};
